import { FISProps, FlightData } from '../types'
import { parseFlight } from '../tracker/parser'
import { getAirportData } from '../utils'

export async function getFlight (props: FISProps): Promise<FlightData[]> {
  const response = await fetch(`https://xml.flightview.com/fvFlightTrackerLive/fvxml.exe?acid=${props.flightNo || ''}&al=${props.airline || ''}&arrdate=${props.arrivalDate || ''}&arrap=${props.arrivalAirport || ''}`)
  const text = await response.text()
  return await parseXml(text)
}

async function parseXml (rawXml: string): Promise<FlightData[]> {
  const parser = new DOMParser()
  const xmlDoc = parser.parseFromString(rawXml, 'text/xml')
  const flights = parseFlight(xmlDoc)
  if (flights) {
    await enrichResponse(flights)
  }
  return flights
}

async function enrichResponse (flights: FlightData[]) {
  for (const flight of flights) {
    flight.departureAirport.coords = await getAirportData(flight.departureAirport.code)
    flight.arrivalAirport.coords = await getAirportData(flight.arrivalAirport.code)
  }
}
